import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/toast"; // ✅ shows toasts (recommended)
import { ToastProvider } from "./hooks/use-toast";
import Dashboard from "./features/Dashboard/Dashboard";
import Claims from "./features/Claims/Claims";
import ClaimView from "./features/Claims/ClaimView";
import Customers from "./features/Customers/Customers";
import ProtectionPlans from "./features/ProtectionPlans/ProtectionPlans";
import ProtectionPlanTemplates from "./features/ProtectionPlanTemplates/ProtectionPlanTemplates";
import CreateProtectionPlanTemplate from "./features/ProtectionPlanTemplates/CreateProtectionPlanTemplate";
import CreateTicket from "./features/CreateTicket/CreateTicket";
import CreateTicketFromMail from "./features/CreateTicket/CreateTicketFromMail";
import AiSettings from "./features/AISettings/AiSettings";
import HomePage from "./features/HomePage/HomePage";

const ProtectedRoutes = lazy(() => import("./routes/ProtectedRoutes"));

function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="p-4 text-center">Loading...</div>}>
          <Routes>
            <Route path="/" element={<ProtectedRoutes />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/claims" element={<Claims />} />
              <Route path="/claimview/:claimId" element={<ClaimView />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/protection-plans" element={<ProtectionPlans />} />
              <Route
                path="/protection-plan-templates"
                element={<ProtectionPlanTemplates />}
              />
              <Route
                path="/create-protection-plan"
                element={<CreateProtectionPlanTemplate />}
              />
              <Route path="/ai-settings" element={<AiSettings />} />
            </Route>
            <Route path="/createticket" element={<CreateTicket />} />
            <Route
              path="/submitticket/:claimId"
              element={<CreateTicketFromMail />}
            />
            <Route path="/createticket/:planId" element={<CreateTicket />} />
            <Route path="/homepage" element={<HomePage />} />
          </Routes>
        </Suspense>

        {/* Toast Viewport (Toast notifications container) */}
        <Toaster />
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
